module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns-house_spot_04-163a1717474285144ca4a070e27302ea.jpg";